<div class="emptyFlexDates__cont">
  <div class="emptyFlexDates__icon">
    <app-ds-icon
      [icon]="iconFlights"
      [size]="25">
    </app-ds-icon>
  </div>
  <div class="emptyFlexDates__messages">
    <app-ds-typography
      [size]="fontSize.XXS"
      [fontFamily]="fontFamily.SemiBold"
      [color]="fontColor.Primary"
      [text]="'FLIGHT_RESULTS_MODULE.FLEX_DATES.EMPTY.SORRY' | transloco">
    </app-ds-typography>
    <div class="emptyFlexDates__messages-subtitle">
      <app-ds-typography
        [size]="fontSize.XXXS"
        [tag]="'p'"
        [color]="fontColor.Secondary"
        [text]="'FLIGHT_RESULTS_MODULE.FLEX_DATES.EMPTY.MESSAGE' | transloco">
      </app-ds-typography>
    </div>
  </div>
</div>